import { ICreateBiometriaFacialUseCase } from "../../../presentation/useCases/create/create_biometria_facial_use_case";
import { IRhRepository } from "../../repositories/rh_repository";


export class CreateBiometriaFacialUseCase implements ICreateBiometriaFacialUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async createBiometriaFacial(
    idFuncionario: number,
    biometriaBase64: string,
  ): Promise<string> {
    const response = await this.repository.createBiometriaFacial(
      idFuncionario,
      biometriaBase64,
    );
    console.log({response});
    return response.gryfoRequestId;
  }
}
